// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tooltip-content {\n    background: #001E38;\n    color: #fff;\n}\n.disabled-pointer {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.pointer {\n  cursor: pointer;\n}\n\n", ""]);
// Exports
module.exports = exports;
